"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = exports.VisibilityState = exports.ActionCloseType = void 0;
var jschannel = require("@greenova/jschannel");
var defaultMargin = 15;
var ActionCloseType;
(function (ActionCloseType) {
    ActionCloseType[ActionCloseType["nativeClose"] = 1] = "nativeClose";
    ActionCloseType[ActionCloseType["templateClose"] = 2] = "templateClose";
    ActionCloseType[ActionCloseType["innerActionClose"] = 3] = "innerActionClose";
    ActionCloseType[ActionCloseType["systemClose"] = 4] = "systemClose";
})(ActionCloseType = exports.ActionCloseType || (exports.ActionCloseType = {}));
var VisibilityState;
(function (VisibilityState) {
    VisibilityState[VisibilityState["none"] = 0] = "none";
    VisibilityState[VisibilityState["shown"] = 1] = "shown";
    VisibilityState[VisibilityState["hidden"] = 2] = "hidden";
})(VisibilityState = exports.VisibilityState || (exports.VisibilityState = {}));
//interface IPanelActionCallArgs {
//    actionToken: string;
//    closePanel: boolean;
//}
var Overlay = /** @class */ (function () {
    function Overlay(args) {
        var _this = this;
        this.opened = false;
        this.destroyed = false;
        this.contentLoaded = false;
        this.openRequest = false;
        this.rootElementHovered = false;
        this.closeEventTimeoutId = undefined;
        this.communicationReady = false;
        this.isOverlayAction = false;
        this.asyncContentReady = false;
        this.contentLoadTimeout = 1000;
        this.marginTop = defaultMargin;
        this.marginBottom = defaultMargin;
        this.marginLeft = defaultMargin;
        this.marginRight = defaultMargin;
        this.actionId = null;
        this.closeOnEscKey = false;
        this.transparent = false;
        this.lastMaxSize = { height: 0, width: 0, useMaxDynamicDimensions: false };
        this.defaultSize = {
            width: 646,
            height: 462
        };
        this.readyToShow = false;
        this.isHidden = false;
        this.isShown = false;
        this.onOpenCalled = false;
        this.onReadyToShowCalled = false;
        this.isCloseRequested = false;
        this.hiddenGroups = [];
        this.onError = function (error, message) {
            if (typeof console !== 'undefined')
                console.info('SLError: ' + error + ' | ' + message);
            _this.useDynamicDimensions = false;
            _this.setDimensions(_this.defaultSize, _this.getMaxSize());
            _this.communicationRequired = false;
            _this._updateDynamicSize(false);
        };
        this._onContentLoaded = function () {
            _this.initContentCommunication();
            _this.setupContentScript();
            window.setTimeout(function () {
                if (_this.onContentLoaded)
                    try {
                        _this.onContentLoaded();
                    }
                    catch (e) { }
                if (_this.useDynamicDimensions) {
                    _this.getOverlayMSize(_this.onError, function (overlayMSize) {
                        _this.overlayMSize = overlayMSize;
                        _this._updateDynamicSize(false);
                    }, _this.communicationTimeoutMs);
                }
                else {
                    _this.resizeStaticRootDiv();
                    _this._showContent();
                    _this.showInternal();
                }
            }, _this.contentLoadTimeout);
        };
        this._onResize = function () {
            _this.resize(false);
        };
        //private _onScroll = () => {
        //    console.log("Scroll");
        //    console.log("window.innerHeight: " + window.innerHeight);
        //    console.log("document.documentElement.clientHeight: " + document.documentElement.clientHeight);
        //    console.log("document.body.clientHeight: " + document.body.clientHeight);
        //    console.log("document.documentElement.scrollHeight: " + document.documentElement.scrollHeight);
        //    console.log("document.scrollingElement.scrollTop: " + (document.scrollingElement != null && document.scrollingElement.scrollTop != null ? document.scrollingElement.scrollTop : 'undefined'));
        //    console.log("document.body.scrollTop: " + document.body.scrollTop);
        //    console.log("this.rootElement.clientHeight: " + this.rootElement.clientHeight);
        //    console.log("window.pageYOffset: " + window.pageYOffset);
        //    console.log("window.scrollY: " + window.scrollY);
        //    if (window.innerWidth / document.documentElement.clientWidth != 1)
        //        return;
        //    this.setIOSPosition();
        //}
        this.onOrientationChange = function () {
            _this.resize(true);
        };
        this._onDocumentClick = function () {
            if (!_this.rootElementHovered) {
                _this.closeByUser(true);
            }
        };
        this._onKeyDown = function (evt) {
            if (_this.closeOnEscKey) {
                evt = evt || window.event;
                var isEscape = false;
                if ("key" in evt) {
                    isEscape = (evt.key === "Escape" || evt.key === "Esc");
                }
                else {
                    isEscape = (evt.keyCode === 27);
                }
                if (isEscape) {
                    _this.closeByUser(true);
                }
            }
        };
        this.onContentScriptSetupError = function (error, message) {
            if (typeof console !== 'undefined') {
                console.info('ContentScriptSetupError: ' + error + ' | ' + message);
            }
        };
        if (!Overlay.isBrowserSupported())
            return;
        this.contentUrl = args.contentURL || "about:blank";
        this.closeButtonUrl = args.closeButtonUrl || "https://cdn.smartsignals2.smart-digital-solutions.de/Smasi2/close.svg";
        this.width = args.width || 0;
        this.widthUnit = args.widthUnit || Overlay.unit.PIXEL;
        this.height = args.height || 0;
        this.heightUnit = args.heightUnit || Overlay.unit.PIXEL;
        this.verticalSnap = args.verticalSnap || Overlay.verticalSnap.CENTER;
        //this.verticalMargin = args.verticalMargin || 0;
        //this.verticalMarginUnit = args.verticalMarginUnit || Overlay.unit.PIXEL;
        this.horizontalSnap = args.horizontalSnap || Overlay.horizontalSnap.CENTER;
        //this.horizontalMargin = args.horizontalMargin || 0;
        //this.horizontalMarginUnit = args.horizontalMarginUnit || Overlay.unit.PIXEL;
        this.marginTop = (args.marginTop !== undefined && args.marginTop !== null) ? args.marginTop : defaultMargin;
        this.marginBottom = (args.marginBottom !== undefined && args.marginBottom !== null) ? args.marginBottom : defaultMargin;
        this.marginLeft = (args.marginLeft !== undefined && args.marginLeft !== null) ? args.marginLeft : defaultMargin;
        this.marginRight = (args.marginRight !== undefined && args.marginRight !== null) ? args.marginRight : defaultMargin;
        this.transparent = args.transparent || false;
        this.useDynamicDimensions = args.dynamicDimensions;
        this.modal = args.modal || false;
        this.closeButtonVisible = args.closeButtonVisible !== undefined ? args.closeButtonVisible : true;
        this.closeOnOuterClick = args.closeOnOuterClick || false;
        this.persistent = args.persistent || false;
        this.communicationRequired = args.communicationRequired || false;
        this.communicationTimeoutMs = args.communicationTimeoutMs || 1000;
        this.contentLoadTimeout = (args.contentLoadTimeout || 1) * 1000;
        this.useMaxDynamicDimensions = args.useMaxDynamicDimensions || false;
        this.IOSFlexiblePositioning = args.IOSFlexiblePositioning || false;
        this.TestMode = !!args.TestMode;
        this.marginTopUnit = args.marginTopUnit || Overlay.unit.PIXEL;
        this.marginBottomUnit = args.marginBottomUnit || Overlay.unit.PIXEL;
        this.marginLeftUnit = args.marginLeftUnit || Overlay.unit.PIXEL;
        this.marginRightUnit = args.marginRightUnit || Overlay.unit.PIXEL;
        this.slideInSide = args.slideInSide;
        this.slideInTransition = args.slideInTransition;
        this.slideInEnabled = args.slideInEnabled;
        this.slideOutSide = args.slideOutSide;
        this.slideOutTransition = args.slideOutTransition;
        this.slideOutEnabled = args.slideOutEnabled;
        this.fadeInTransition = args.fadeInTransition;
        this.fadeInEnabled = args.fadeInEnabled;
        this.fadeOutTransition = args.fadeOutTransition;
        this.fadeOutEnabled = args.fadeOutEnabled;
        this.actionId = args.actionId || '';
        this.channelSetup = args.channelSetup;
        this.cssClasses = args.cssClasses;
        this.closeOnEscKey = args.closeOnEscKey;
        if (args.boxShadow) {
            this.boxShadow = {
                verticalOffset: args.boxShadow.verticalOffset,
                horizontalOffset: args.boxShadow.horizontalOffset,
                blur: args.boxShadow.blur || 0,
                color: args.boxShadow.color || "#000",
                spread: args.boxShadow.spread || 0
            };
        }
        this.isAnimationSupported = this.CheckIsAnimationSupported();
        this.setExternalConfigOrDefault();
        this.create();
    }
    Overlay.isBrowserSupported = function () {
        try {
            var div = document.createElement("div");
            div.innerHTML = "<!--[if lt IE 8]><i></i><![endif]-->";
            var isIeLessThan8 = (div.getElementsByTagName("i").length == 1);
            return !isIeLessThan8;
        }
        catch (ignore) { }
        return false;
    };
    Overlay.prototype.isIE8 = function () {
        var div = document.createElement("div");
        div.innerHTML = "<!--[if IE 8]><i></i><![endif]-->";
        var isIe8 = (div.getElementsByTagName("i").length == 1);
        return isIe8;
    };
    Overlay.prototype.isIE = function () {
        var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
        var msie = ua.indexOf('MSIE '); // IE 10 or older
        var trident = ua.indexOf('Trident/'); //IE 11
        return (msie > 0 || trident > 0);
    };
    Overlay.prototype.CheckIsAnimationSupported = function () {
        var elem = document.createElement('div');
        return elem.style.animationName !== undefined && !this.isIE();
    };
    Overlay.prototype.isIOS = function () {
        var iDevices = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ];
        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }
        return false;
    };
    Overlay.prototype.open = function (waitForLoaded) {
        var _this = this;
        if (waitForLoaded === void 0) { waitForLoaded = true; }
        if (this.destroyed || this.opened)
            return;
        if (waitForLoaded && !this.contentLoaded) {
            this.openRequest = true;
            return;
        }
        if (this.communicationRequired && !this.communicationReady) {
            this.openRequest = true;
            return;
        }
        if (this.externalConfig.asyncContent && !this.asyncContentReady) {
            this.openRequest = true;
            return;
        }
        this.openRequest = false;
        if (this.isCloseRequested) {
            this.isCloseRequested = false;
            return;
        }
        try {
            if (this.onOpening && !this.onOpening())
                return;
        }
        catch (e) { }
        this.opened = true;
        if (!this.TestMode) {
            if (this.readyToShow)
                this.showInternal();
            // if (this.modal) {
            //     var currentHtmlStyle = window.document.documentElement.style;
            //     this.htmlStyleBackup = this.createStyleBackup(currentHtmlStyle);
            //     currentHtmlStyle.overflow = currentHtmlStyle.overflowX = currentHtmlStyle.overflowY = "hidden";
            //     var currentBodyStyle = window.document.body.style;
            //     this.bodyStyleBackup = this.createStyleBackup(currentBodyStyle);
            //     currentBodyStyle.overflow = currentBodyStyle.overflowX = currentBodyStyle.overflowY = "hidden";
            //     //if (document.addEventListener) {
            //     //    if ('ontouchmove' in document.documentElement) {
            //     //        document.addEventListener("touchstart", this.ontouchstart);
            //     //        document.addEventListener("touchmove", this.ontouchmove);
            //     //        this.isTouchMoveListenerAdded = true;
            //     //    }
            //     //}
            // }
            if (this.closeOnOuterClick) {
                this.closeEventTimeoutId = window.setTimeout(function () {
                    _this.closeEventTimeoutId = undefined;
                    if (document.addEventListener)
                        document.addEventListener("click", _this._onDocumentClick);
                    else if (document.attachEvent)
                        document.attachEvent('onclick', _this._onDocumentClick);
                }, 500);
            }
            if (this.closeOnEscKey) {
                if (document.addEventListener)
                    document.addEventListener("keydown", this._onKeyDown);
                else if (document.attachEvent)
                    document.attachEvent('onkeydown', this._onKeyDown);
            }
        }
        else {
            this.callOnOpen();
        }
    };
    Overlay.prototype.close = function (actionCloseType) {
        var _this = this;
        this.isCloseRequested = true;
        if (this.destroyed || !this.opened)
            return;
        this.opened = false;
        try {
            if (this.onClose)
                this.onClose(actionCloseType);
        }
        catch (e) { }
        if (this.closeOnOuterClick) {
            if (this.closeEventTimeoutId) {
                window.clearTimeout(this.closeEventTimeoutId);
                this.closeEventTimeoutId = undefined;
            }
            else {
                if (document.removeEventListener)
                    document.removeEventListener('click', this._onDocumentClick);
                else if (document.detachEvent)
                    document.detachEvent('onclick', this._onDocumentClick);
            }
        }
        if (this.closeOnEscKey) {
            if (document.removeEventListener)
                document.removeEventListener("keydown", this._onKeyDown);
            else if (document.detachEvent)
                document.detachEvent('onkeydown', this._onKeyDown);
        }
        if (this.fadeOutEnabled || this.slideOutEnabled)
            this.CreateOutAnimations(this.rootElement);
        var waitForAnimation = 0;
        if (this.isAnimationSupported) {
            if (this.slideOutEnabled && this.fadeOutEnabled)
                waitForAnimation = Math.min(this.fadeOutTransition, this.slideOutTransition);
            else if (this.slideOutEnabled)
                waitForAnimation = this.slideOutTransition;
            else if (this.fadeOutEnabled)
                waitForAnimation = this.fadeOutTransition;
        }
        if (waitForAnimation > 0) {
            setTimeout(function () { return _this.closeAndHide(); }, waitForAnimation);
            this.rootElement.style.animationPlayState = "running";
        }
        else {
            this.closeAndHide();
        }
    };
    Overlay.prototype.closeAndHide = function () {
        this.rootElement.style.display = "none";
        this.overlay.style.display = "none";
        this.restoreStyleBackup(this.bodyStyleBackup, window.document.body.style);
        this.restoreStyleBackup(this.htmlStyleBackup, window.document.documentElement.style);
        this.bodyStyleBackup = undefined;
        this.htmlStyleBackup = undefined;
        try {
            if (this.onCloseDone)
                this.onCloseDone();
        }
        catch (e) { }
    };
    Overlay.prototype.setContentURL = function (contentURL) {
        this.contentLoaded = false;
        this.communicationReady = false;
        this.asyncContentReady = false;
        this.iframe.src = contentURL;
    };
    Overlay.prototype.CalcMarginPixels = function (percentage) {
        var windowSize = this.getWindowInnerSize();
        var result = Math.round((windowSize.width * percentage) / 100);
        return result;
    };
    Overlay.prototype.CalcAllMarginsPx = function () {
        this.pixelMargin = { top: this.marginTop, bottom: this.marginBottom, left: this.marginLeft, right: this.marginRight };
        if (this.marginTopUnit === Overlay.unit.PERCENTAGE) {
            this.pixelMargin.top = this.CalcMarginPixels(this.marginTop);
        }
        if (this.marginBottomUnit == Overlay.unit.PERCENTAGE) {
            this.pixelMargin.bottom = this.CalcMarginPixels(this.marginBottom);
        }
        if (this.marginLeftUnit == Overlay.unit.PERCENTAGE) {
            this.pixelMargin.left = this.CalcMarginPixels(this.marginLeft);
        }
        if (this.marginRightUnit == Overlay.unit.PERCENTAGE) {
            this.pixelMargin.right = this.CalcMarginPixels(this.marginRight);
        }
    };
    Overlay.prototype.AdjustIOSOverlayPosition = function () {
        var dh = document.documentElement.scrollHeight;
        var vh = window.innerHeight; //document.documentElement.clientHeight;
        var st = (document.scrollingElement || document.body).scrollTop;
        var ch = this.rootElement.clientHeight;
        //var top = Math.max((st + (vh - ch) / 2), st + defaultMargin);
        this.CalcAllMarginsPx();
        var top = st + this.pixelMargin.top;
        if (this.verticalSnap == Overlay.verticalSnap.CENTER) {
            top = Math.max((st + (vh - ch) / 2), st + this.pixelMargin.top);
        }
        else if (this.verticalSnap == Overlay.verticalSnap.BOTTOM) {
            top = Math.max((st + (vh - ch)) - this.pixelMargin.bottom, st + this.pixelMargin.top);
        }
        var dw = document.documentElement.scrollWidth;
        var vw = document.documentElement.clientWidth;
        var sl = (document.scrollingElement || document.body).scrollLeft;
        var cw = this.rootElement.clientWidth;
        //var left = Math.max((sl + (vw - cw) / 2), sl + defaultMargin);
        var left = sl + this.pixelMargin.left;
        if (this.horizontalSnap == Overlay.horizontalSnap.CENTER) {
            left = Math.max((sl + (vw - cw) / 2), sl + this.pixelMargin.left);
        }
        else if (this.horizontalSnap == Overlay.horizontalSnap.RIGHT) {
            left = Math.max((sl + (vw - cw)) - this.pixelMargin.right, sl + this.pixelMargin.left);
        }
        if (!this.positionSet) {
            this.positionSet = {
                top: top,
                left: left,
                width: this.width,
                height: this.height
            };
            this.rootElement.style.top = top + Overlay.unit.PIXEL;
            this.rootElement.style.left = left + Overlay.unit.PIXEL;
        }
        else {
            if (this.positionSet.height > this.height) {
                if (this.positionSet.top < st) {
                    window.scrollBy(undefined, this.height - this.positionSet.height);
                }
            }
            this.positionSet.width = this.width;
            this.positionSet.height = this.height;
            //this.rootElement.style.top = top + Overlay.unit.PIXEL;
            this.rootElement.style.left = left + Overlay.unit.PIXEL;
        }
    };
    Overlay.prototype.setDimensions = function (dimensions, maxSize) {
        var width = dimensions.width;
        var height = dimensions.height;
        if (maxSize && this.useDynamicDimensions) {
            if (maxSize.width)
                width = Math.min(width, maxSize.width);
            if (maxSize.height && (!this.isIOS() || this.IOSFlexiblePositioning))
                height = Math.min(height, maxSize.height);
        }
        this.width = width;
        this.height = height;
        this.rootElement.style.width = this.width.toString() + Overlay.unit.PIXEL;
        this.rootElement.style.height = this.height.toString() + Overlay.unit.PIXEL;
        if (this.isIOS() && !this.IOSFlexiblePositioning) {
            this.AdjustIOSOverlayPosition();
        }
    };
    Overlay.prototype.closeByUser = function (nativeClose) {
        if (!this.opened)
            return;
        try {
            if (this.onCloseByUser)
                this.onCloseByUser();
        }
        catch (e) { }
        this.close(nativeClose ? ActionCloseType.nativeClose : ActionCloseType.templateClose);
    };
    Overlay.prototype.createContentCommunication = function (scopeName) {
        return jschannel.build({
            window: this.iframe.contentWindow,
            origin: "*",
            scope: scopeName,
            reconnect: true
        });
    };
    Overlay.prototype.initContentCommunication = function () {
        var _this = this;
        if (this.chan) {
            this.chan.destroy();
        }
        this.chan = this.createContentCommunication("smasi-lightbox");
        this.chan.bind("contentHandshake", function (trans, externalConfig) { return _this._contentHandshake(externalConfig); });
        this.chan.bind("contentCommunicationReady", function () { return _this._contentHandshake({}); }); // TODO: For backward compatibility. Can be removed after some time.
        this.chan.bind("closeByUser", function () { return _this.closeByUser(false); });
        this.chan.bind("panelAction", function (trans, actionData) { _this.panelAction(trans, actionData); });
        this.chan.bind("contentDOMChanged", function () { return _this._contentDOMChanged(); });
        this.chan.bind("asyncContentReady", function () { return _this._asyncContentReady(); });
        this.chan.bind("sizeChanged", function () { return _this._sizeChanged(); });
        this.chan.bind("clicked", function () { return _this._clicked(); });
        if (this.channelSetup)
            this.channelSetup(this.chan);
    };
    Overlay.prototype.divOnIframeStyle = function () {
        var divOnIframeStyle = this.divOnIframe.style;
        divOnIframeStyle.width = "100%";
        divOnIframeStyle.height = "100%";
        divOnIframeStyle.display = "block";
        divOnIframeStyle.cssText += "-webkit-overflow-scrolling: touch;";
        divOnIframeStyle.overflowY = "auto";
    };
    Overlay.prototype.rootElementStyle = function () {
        var rootElementStyle = this.rootElement.style;
        rootElementStyle.display = this.TestMode ? "none" : "block";
        rootElementStyle.zIndex = "100000";
        rootElementStyle.position = (!this.isIOS() || this.IOSFlexiblePositioning) ? "fixed" : "absolute";
        rootElementStyle.minHeight = "30px";
        rootElementStyle.minWidth = "30px";
        if (!this.isIOS() || this.IOSFlexiblePositioning) {
            //rootElementStyle.marginTop = "auto";
            //rootElementStyle.marginBottom = "auto";
            //rootElementStyle.top = "0";
            //rootElementStyle.bottom = "0";
            //rootElementStyle.marginLeft = "auto";
            //rootElementStyle.marginRight = "auto";
            //rootElementStyle.left = "0";
            //rootElementStyle.right = "0";
            if (this.verticalSnap == Overlay.verticalSnap.CENTER || this.isFullHeight()) {
                rootElementStyle.marginTop = "auto";
                rootElementStyle.marginBottom = "auto";
                rootElementStyle.top = this.marginTop + this.marginTopUnit;
                rootElementStyle.bottom = this.marginBottom + this.marginBottomUnit;
            }
            else if (this.verticalSnap == Overlay.verticalSnap.TOP) {
                rootElementStyle.marginBottom = "auto";
                rootElementStyle.top = this.marginTop + this.marginTopUnit;
                rootElementStyle.bottom = this.marginBottom + this.marginBottomUnit;
            }
            else if (this.verticalSnap == Overlay.verticalSnap.BOTTOM) {
                rootElementStyle.marginTop = "auto";
                rootElementStyle.bottom = this.marginBottom + this.marginBottomUnit;
                rootElementStyle.top = this.marginTop + this.marginTopUnit;
            }
            if (this.horizontalSnap == Overlay.horizontalSnap.CENTER || this.isFullWidth()) {
                rootElementStyle.marginLeft = "auto";
                rootElementStyle.marginRight = "auto";
                rootElementStyle.left = this.marginLeft + this.marginLeftUnit;
                rootElementStyle.right = this.marginRight + this.marginRightUnit;
            }
            else if (this.horizontalSnap == Overlay.horizontalSnap.LEFT) {
                rootElementStyle.marginRight = "auto";
                rootElementStyle.left = this.marginLeft + this.marginLeftUnit;
                rootElementStyle.right = this.marginRight + this.marginRightUnit;
            }
            else if (this.horizontalSnap == Overlay.horizontalSnap.RIGHT) {
                rootElementStyle.marginLeft = "auto";
                rootElementStyle.left = this.marginLeft + this.marginLeftUnit;
                rootElementStyle.right = this.marginRight + this.marginRightUnit;
            }
        }
        //if (this.isIE8() || this.isIOS()) {
        //    rootElementStyle.maxHeight = "none";
        //}
    };
    Overlay.prototype.getMaxSize = function () {
        var windowInnerSize = this.getWindowInnerSize();
        var width = windowInnerSize.width;
        this.CalcAllMarginsPx();
        if (!this.isFullWidth()) {
            width -= (this.pixelMargin.left + this.pixelMargin.right);
            width = Math.abs(width);
            //if (this.horizontalSnap != Overlay.horizontalSnap.CENTER) {
            //    width -= this.getHorizontalMarginInPixels();
            //    width += this.MAX_SIZE_OFFSET * 0.5;
            //}
        }
        var height = windowInnerSize.height;
        if (!this.isFullHeight()) {
            height -= (this.pixelMargin.bottom + this.pixelMargin.top);
            height = Math.abs(height);
            //if (this.verticalSnap != Overlay.verticalSnap.CENTER) {
            //    height -= this.getVerticalMarginInPixels();
            //    height += this.MAX_SIZE_OFFSET * 0.5;
            //}
        }
        var maxSize = { width: width, height: height, useMaxDynamicDimensions: this.useMaxDynamicDimensions };
        if (this.overlayMSize) {
            if (this.overlayMSize.width)
                maxSize.width = Math.min(this.overlayMSize.width, maxSize.width);
            if (this.overlayMSize.height)
                maxSize.height = Math.min(this.overlayMSize.height, maxSize.height);
        }
        return maxSize;
    };
    //private getVerticalMarginInPixels(): number {
    //    return this.verticalMarginUnit == Overlay.unit.PIXEL ? this.verticalMargin : this.getWindowInnerSize().height * (this.verticalMargin * 0.01);
    //}
    //private getHorizontalMarginInPixels(): number {
    //    return this.horizontalMarginUnit == Overlay.unit.PIXEL ? this.horizontalMargin : this.getWindowInnerSize().width * (this.horizontalMargin * 0.01);
    //}
    Overlay.prototype.btnCloseStyle = function () {
        var _this = this;
        this.btnClose.onclick = function () { return _this._onCloseBtnClicked(); };
        // this.btnClose.src = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMCIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIzMS44cHgiIGhlaWdodD0iMzAuMnB4IiB2aWV3Qm94PSIwIDAgMzEuOCAzMC4yIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMS44IDMwLjIiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCQoJCTxpbWFnZSBvdmVyZmxvdz0idmlzaWJsZSIgb3BhY2l0eT0iMC43NSIgd2lkdGg9Ijg4IiBoZWlnaHQ9Ijg4IiB4bGluazpocmVmPSJkYXRhOmltYWdlL3BuZztiYXNlNjQsaVZCT1J3MEtHZ29BQUFBTlNVaEVVZ0FBQUZzQUFBQmJDQVlBQUFBY052bVpBQUFBQ1hCSVdYTUFBQ0d1QUFBaHJnR3BzdW1pQUFBQQpHWFJGV0hSVGIyWjBkMkZ5WlFCQlpHOWlaU0JKYldGblpWSmxZV1I1Y2NsbFBBQUFDaXRKUkVGVWVOcnNYVjF2MnpnUUpDblpUcG8wCjZmWDEwUC8vdzRwN3Z0YUpHMzlKdWhvUWU5dnA3SktVWlZzT0xHQWh4ekZzYVRRYUxwZTdLK2R1MjIyN2JiZnRxTTFQL1FDL2ZQazcKOXppN3IxLy91WUU5QXFoWllFLzlJdmlKQWV5UE9NWXU0LzJMQXU4bkJMQzJIOExzVHV5N3FRRHZMd1N5M09OclQ5NjNqdFVDbWRuRgpnUGNYQnZsZ0FmYjQyZ0tkZ1h2WTJ2NDE3aTNnVHc2NHZ4RElBVUN1eEhzQi9xK0Jyb0V0QVQ1WUkxNjNBSHhMNU9aa29Qc3pBWTBnCkJ3Rnl0RnFBTHZjYTRBZzBBNWtadXdBZGZ0OHBBUGNuQkZvRFdZS0xObE9BWjRCclFFZFE5MksvZzcvM0FINUxwR1owbHZzVHNqa0EKMEJXQUd2ZnozbVpna3ZVaEEreG9lN0J0RC9aT3ZKWVhZSytBUGpyTC9SbllqQ0JIZ0JkaXZ4Qi96OFhGcUFIc1FEd1JsQTRFZWR2YgpwcmN0bUFiNmI0UHBHSUQ3RXdETjVFSXkrQURxbldJUjlKa0F2QkpTWW9FdHBZT0J2QWFMNzFtZ2p3cTRIeEhveUQ0TlpBbnFmVzhmCnhHc0orQnprQkwwVENUYVRrQjBCK2szWUQvRjZEYXpmV1N3L0JuQS9JdERSNHUyUElFZHdvejJJdlFSOEFWTENkSnU1ZXhyWURPalgKZmk5dERVeVAzelVhNEg1RW9Dc0FlZ0VNZnVqdHNiY0hBZmdIQmV3S1pFU2FCblpqZ0gwQWRkWGJxN0FWQVgwbldENEs0UFhJUU04RQpteVhJQjNBL3d2NlJnQzBIeVhqaDBQMURQNXU1ZmRMN1dBdkFWK1MzWmpBUU03bmFpOStLT0JRRFhnKzhHNlJKb09QZ0Z3SDhLT3dKCi9uNEVXYmtqUUROV1c1TWFaUGNPQmtmNVczSXdyaFdwY21NQ1hnOWd0WU5wZGtXQWZoUUFIK3hadkk1Z1J4bUpkOEU4ZzJrVzJKYWMKUklhajF6TlhYRXl2ZUQwc2tqZysySXFMVjRIZkhJR1dJSC9xVFlMOUtBYkdPK1BFZ3pGN1pQR1JLQ2tOekI1M0NYOWVtemhaMGNLMgpsTjNWRVRxTkdpMkJqaUIvL21sL0NaUEFQeXFleUF5QXI0bXNWR1NHS1YvWEpPYUMreW9ENU5hWVdmN2FucCtmM0hMNU1ocXpNYWpFCmRQcEJnUDJKZ1B3a0JrWUVWMk8wSTR6Mnh1cU1aR0lsQnMzYXVIZ1laZFNBYnBXUWJmWldEV0ExQW4wdk5QcFpBUDJaZ1AwRVdvM2UKUjZXRVc3MFI2L2FKK0hobGhIRTlYRmduSkNJSDZLNkUzWFdoOThFR3hYdEZRcUk5ZzJ5ZzF4R00yem0xU29Nc1J4bndZaC9JQkV5VApEb3dRcGlLRnh6UGJZTFgwcGFWMG9FNC9pMEZSRG9qYURERjNVRXlSd21XeUhwbmRGY1RFaTlsZEY3S2FBUjRuTHRMVmV3Si8rZ0VtCkVwWStqeEVnUTQzdkV0OXZUWXEwS0dIOGJKZkxjSlBaUDYrVXhlb1BoTlZScTZOOGZJUUJNZVZ1ZVRmdWdvYkdkS2ZJRldNMXhyNVoKa0tyTllYZGRNSUVKeG16eHdaaUszeW1NUGhYQUthWUh4VmR2alNBV2htWWp3NnNlZUovRDdMcGdXbzZUbUR1STREMUFjQW5kdStwQwpRS2NBNy9yemFmcGpabUQvNk05SmhtUWoyeU1SazY1Z3lMd05OVmJmRTdBeDFqRzdJS056UGFzYUZqYTA4Mkxqemg4UlNhRUthV2JECmg3MFMyY09nRTBidnJNSHdFa0JyZzJjRk1oTGQyVTNQWkF3QjMvWHY0OEpHbTVLVHVrQkNnc0xzZXpMbFhtUUdsQzY1TVM4cm50dVcKTEhoWWl4c2g1NXh5WkNUQUZKMnRKYkw0eHN4WVpaa0MwSnBNc25PVWhFS3dzNGtVTXZXdFVsWmlGaVJraWFzc1ZrYlRWTml0alVzTAo0enpOZUE3VDdXRE1HcDB4VForVGc1a25na3BUUzd6MzVBN1d4aWJ0UExVbHUyeG1lMFBUWk82SFhEbWZrNEJTbURpcmN6d1U3UnkxCmxmK2pOTnNwbWpZalAxN0R1dUdVV1oxRHJBcEloUmxidGFIWnZnUnNLMDhQMDhkcWw1ZmpNZlg2SFM4d1lVbWZNMFVtcTF4Q2hZSmIKckNJSFVDc3JIMU56ODByako4RllGYXFIem9aRDVpMFdGRTJyTXFSajhoVnBSa2lXa2N4YTJQanQrOUFqQ2NiTTBaSVR6YlNyZkMyQQpheE9la2tUOWJNMjJWa29zNFAwVnljWVFkdWNzeXlXM2NJS0RZVnI0SGpackZTanI3ZzN1dHAxdEt3Vzd5ekQ4N0h2WldGWVV2bWR1Ck5mbENiYy9TdkdpVy9qc0ExTEpVbVY4ZXMwa2FsUVZ3V3dCNmQ2V2dsNTZyQ1g1SS9LQnplZFZZZTJlWHVsMHpxMWthZzFWaDl1djcKa0x5aDRBRHdSMW55U3BOeEVOZWl4VnJPQ0NiclpNdEp5QUJaWGtWYzJwZjduUUwydFVpSnpFN1YwaGxZa1ZPVFM2cVFlUkJZOW9ZSgpMSmhYMFJxZ1R4RmdxOFJQMWsvdUNPalpUa0lZY0FEeUIxbkdrRmJhTmxWMjQ5aVVPbGVyYnJLTTJiMm9NOEJsYXBZc2UyTmxiZnVFCnBFd0paT2Zzd3RXTmNhNE55SWg1bmlsdkJBY0xkaEJZUjJnZHlOVFliZDI5MjB4UzBXUjVWbzBRTXZXNkV3Y2lEMEpXWW1HMjBFNFoKdGErQjFlejgxZ2F6czd5dnVuRGdpRmVkRlhQaUFjbFY5aW11M0xEcVlDeDRlaU8yY1hwUmFyazNBcmRBcDl4aUVYQ3NsSDBEQnV3bgo1bit6U1F1ZUYxWUUvd0F5cGFTeWlObE9HU0FaczJQVkxLYWZ5VFU3YzBYalFrQXpQM3BMemd1cmY1TWswcXJINmtJZnRJR0QrdEdECnk4QkdHY0ZzLzNNRGJnRXRHYzFLcmxmQWJ1bHJON2wzcVpvTWYwam83cFBoTVhpZTJ3MUhXN2U3Qk1NN3c0M2RDS0FQd0I0eTJiLy8KdEc5Z1MvZC9nNEUzWlU3eEM3c2hNcUxwdG1TQ1RNK0todmtrUVJrZnJDU2hVMHhZT21XK3NCWnNmZ0dMekdhNTJZMHJhQ0JRWng2cwpVOXlqS0NXeU00NlZrNDFNcTR3TDRVY0NXV3VUSVFtekVxeGU5c3orTHRpOEVwcTlWYWJwdzJVRXBFU3JRd2tGZGt4Nmd6OEM1QnlnCkk4aFJNdjd0OXhGMHllNE4wZXVzdGhoMXdRazR3ZXdnOUk0MTJtSjlRalFBWnU3UHpLSllOaUVMaTN6QkpNWFM2QjE0SEsrQ3pkOEEKNUNWaE5YUDUzTkhNSmdObGJsdFBMUjJpVThCeExyMkdhYTJLYUJjU0EwcHlickJTQmtQSjZoY3hLRXE5L21QbW1OTXNvR1NBOURBUgowSElCV1ZZbmM3ZWlMY0NMa1N6UGtaOHVNUkEyeW9SRmVoN2ZCY2pmUUs5UnF4dFhXTm1ield6QjdxRjZtbUlmcXczSFlrNjJiNDJWCkZObHFicVBJeHBLNGQram1hVG85cUlWUmxYdFZBSENmQWE2bG4xYXBjcU44amdHOGh5Qy9GaWlUazVTbDBPaC9oWlVBM2JvQnZhS0sKT3VrY3ZyalBCNVJWcmI0L0dMYTFNUFBFUU0vYThWb1ZyYTVkYXpYWEdjdFlqTmt2d2dOWkN0bVFHbzJENG42b2ZBd0NXeG5jR2tOUwpNS0xHSW9aYUpWYXExWndXdWNQK1VHd2EvZ0tBdnlqVGNnVDZxQTVvcDJnMXg0cFNZNTI3Tk96cngyYWZXbm1mdHJpQmQ5QkdDU3k5CkNvYWZyZFhjMkUwVXNhTE1hcUFvcTJabGFkL2NwUnNwdWtUMGpyV1pleE5ncjVTSTN2U2FLQ1lBWjEwcnRTSlZCUHFPVFB1MWVrcXIKZzhMVzJSMHJNVWE5ZGxOdUQyb0F6dnF4WWdrMmEzNWIwbTFZaTdYdmlZeGcwMXZzc3JBbGJKNWU0MXNGY0szVHNHVDZIRmkvTUlKWgpzMHdad2NIUldyVEZ4ZW1kdTRhV3pnYmdGdWhZNWpaM3ZBU3V6aGdnTmQ5YnkvbEFnRm52cCtrMkt5ZUFhMW91ZSs3Vnh1SkREWjlqCkpYQXNEcUkxMDlLNndhZnlFNmZaaGorRDVWb2NwU1lYZ1RWSURIQVJPeElMUVgrYlRlV3RKM3lNenVhekxFVVpUL1RRMnI0RngzdncKWVZmNDFBTW1yRWVtTk9TenpsM3pvMU1NbHVQcjRQUm4xN0MyY0Q0anlOVW05dmg4R25jT29NOENObUc1UzZ6OE9DTzhtdW95bkJQcgpwckgwZC9HNHEwTGdOZWx4R1FzUnFYb2dHdHM1NThQY3B2eUlRaXRWamZWaXNoSTNKL0dZd3FrL2ZIUEk4Vkd3cC9BQXpzbFc0Qlk4ClRuYVN3TjYyMjNiYmJ0dHR1Kzd0UHdFR0FLOENxYlhxbEl6UkFBQUFBRWxGVGtTdVFtQ0MiIHRyYW5zZm9ybT0ibWF0cml4KDAuMzI4NiAwIDAgMC4zMjg2IDEuNTE4IDAuMzk3OCkiPgoJPC9pbWFnZT4KCTxnPgoJCTxnPgoJCQk8ZWxsaXBzZSB0cmFuc2Zvcm09Im1hdHJpeCgwLjcwNzEgLTAuNzA3MSAwLjcwNzEgMC43MDcxIC01LjcxMyAxNS42NDA3KSIgZmlsbD0iIzFEMUQxQiIgY3g9IjE2IiBjeT0iMTQuNyIgcng9IjkuNSIgcnk9IjkuNSIvPgoJCTwvZz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTE2LDI0LjljLTIuNiwwLTUuMi0xLTcuMi0zbDAsMGMtNC00LTQtMTAuNSwwLTE0LjRjNC00LDEwLjUtNCwxNC40LDBjNCw0LDQsMTAuNSwwLDE0LjQKCQkJCUMyMS4zLDIzLjksMTguNiwyNC45LDE2LDI0Ljl6IE05LjgsMjFjMy40LDMuNCw5LjEsMy40LDEyLjUsMGMzLjQtMy40LDMuNC05LjEsMC0xMi41QzE4LjgsNSwxMy4yLDUsOS44LDguNQoJCQkJQzYuMywxMS45LDYuMywxNy41LDkuOCwyMUw5LjgsMjF6Ii8+CgkJPC9nPgoJPC9nPgo8L2c+CjxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0xNi45LDE0LjlsMi44LTIuOGMwLjMtMC4zLDAuMy0wLjcsMC0xYy0wLjMtMC4zLTAuNy0wLjMtMSwwTDE2LDEzLjlsLTIuOC0yLjhjLTAuMy0wLjMtMC43LTAuMy0xLDAKCXMtMC4zLDAuNywwLDFsMi44LDIuOGwtMi44LDIuOGMtMC4zLDAuMy0wLjMsMC43LDAsMWMwLjEsMC4xLDAuMywwLjIsMC41LDAuMmMwLjIsMCwwLjQtMC4xLDAuNS0wLjJsMi44LTIuOGwyLjgsMi44CgljMC4xLDAuMSwwLjMsMC4yLDAuNSwwLjJjMC4yLDAsMC40LTAuMSwwLjUtMC4yYzAuMy0wLjMsMC4zLTAuNywwLTFMMTYuOSwxNC45eiIvPgo8L3N2Zz4K";
        //this.btnClose.src = "data:image/png;base64,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";
        this.btnClose.src = this.closeButtonUrl;
        this.btnClose.alt = 'Close';
        var BTN_HEIGHT = 32;
        var BTN_WIDTH = 32;
        var btnCloseStyle = this.btnClose.style;
        btnCloseStyle.position = "absolute";
        btnCloseStyle.zIndex = "100020";
        btnCloseStyle.right = (BTN_WIDTH * -0.5) + Overlay.unit.PIXEL;
        btnCloseStyle.top = (BTN_HEIGHT * -0.5) + Overlay.unit.PIXEL;
        btnCloseStyle.width = BTN_WIDTH + Overlay.unit.PIXEL;
        btnCloseStyle.height = BTN_HEIGHT + Overlay.unit.PIXEL;
        btnCloseStyle.cursor = "pointer";
        btnCloseStyle.display = this.closeButtonVisible ? "block" : "none";
        //if (this.isFullWidth() || (this.horizontalSnap == Overlay.horizontalSnap.RIGHT && this.getHorizontalMarginInPixels() < BTN_WIDTH * 0.5)) {
        //    btnCloseStyle.right = "0";
        //}
        //if (this.isFullHeight() || (this.verticalSnap == Overlay.verticalSnap.TOP && this.getVerticalMarginInPixels() < BTN_HEIGHT * 0.5)) {
        //    btnCloseStyle.top = "0";
        //}
    };
    Overlay.prototype.overlayStyle = function () {
        var overlayStyle = this.overlay.style;
        overlayStyle.display = this.modal && !this.TestMode ? "block" : "none";
        overlayStyle.zIndex = "99990";
        overlayStyle.position = "fixed";
        overlayStyle.top = "0";
        overlayStyle.left = "0";
        overlayStyle.width = "100%";
        overlayStyle.height = "100%";
        overlayStyle.filter = "alpha(opacity=40)";
        overlayStyle.backgroundColor = "#000";
        overlayStyle.opacity = "0.40";
    };
    Overlay.prototype.getWindowWidth = function () {
        return document.documentElement.clientWidth || window.innerWidth || document.body.clientWidth;
    };
    Overlay.prototype.getWindowHeight = function () {
        return document.documentElement.clientHeight || window.innerHeight || document.body.clientHeight;
    };
    Overlay.prototype.createInAnimations = function (element) {
        if (!this.isAnimationSupported) {
            return;
        }
        var animationElementId = 'smasi-action-in-' + this.actionId;
        var animationStyles = document.getElementById(animationElementId);
        if (!animationStyles) {
            var finalPos = element.getBoundingClientRect();
            animationStyles = document.createElement("style");
            animationStyles.id = animationElementId;
            animationStyles.innerHTML = "\n        @keyframes smasi-slideinleft-{{id}} {\n            from {\n              left: unset;\n              right: 100%;\n              margin-left: unset;\n              margin-right: unset;\n              }\n\n            to {\n              margin-left: unset;\n              margin-right: unset;\n              left: unset;\n              right: {{finalRightPosition}};\n            }\n          }\n\n          @keyframes smasi-slideinright-{{id}} {\n            from {\n              right: unset;\n              left: 100%;\n              margin-left: unset;\n              margin-right: unset;\n              }\n\n            to {\n              right: unset;\n              left: {{finalLeftPosition}};\n              margin-left: unset;\n              margin-right: unset;\n            }\n          }\n\n          @keyframes smasi-slideintop-{{id}} {\n            from {\n              top: unset;\n              bottom: 100%;\n              margin-top: unset;\n              margin-bottom: unset;\n              }\n\n            to {\n              top: unset;\n              bottom: {{finalBottomPosition}};\n              margin-top: unset;\n              margin-bottom: unset;\n            }\n          }\n\n          @keyframes smasi-slideinbottom-{{id}} {\n            from {\n              bottom: unset;\n              top: 100%;\n              margin-top: unset;\n              margin-bottom: unset;\n              }\n\n            to {\n              bottom: unset;\n              top: {{finalTopPosition}};\n              margin-top: unset;\n              margin-bottom: unset;\n            }\n          }\n\n          @keyframes fadein-{{id}} {\n            from { opacity: 0; }\n            to   { opacity: 1; }\n          }\n\n          @keyframes fadeout-{{id}} {\n            from { opacity: 1; }\n            to   {\n                opacity: 0;\n            }\n          }\n        }\n               ".replace(/{{finalRightPosition}}/g, (this.getWindowWidth() - finalPos.right) + "px")
                .replace(/{{finalLeftPosition}}/g, finalPos.left + "px")
                .replace(/{{finalBottomPosition}}/g, (this.getWindowHeight() - finalPos.bottom) + "px")
                .replace(/{{finalTopPosition}}/g, finalPos.top + "px")
                .replace(/{{id}}/g, this.actionId);
            element.appendChild(animationStyles);
            var animations = [];
            if (this.slideInEnabled) {
                var animationName = "";
                if (this.slideInSide == "3" /* left */)
                    animationName = 'smasi-slideinleft';
                else if (this.slideInSide == "4" /* right */)
                    animationName = 'smasi-slideinright';
                else if (this.slideInSide == "1" /* top */)
                    animationName = 'smasi-slideintop';
                else if (this.slideInSide == "2" /* bottom */)
                    animationName = 'smasi-slideinbottom';
                animations.push(animationName + "-" + this.actionId + " " + this.slideInTransition + "ms" + " linear");
            }
            if (this.fadeInEnabled) {
                animations.push("fadein-" + this.actionId + " " + this.fadeInTransition + "ms" + " linear");
            }
            element.style.animation = animations.join(",");
            element.style.animationPlayState = "paused";
        }
    };
    Overlay.prototype.CreateOutAnimations = function (element) {
        if (!this.isAnimationSupported) {
            return;
        }
        var animations = [];
        if (this.slideOutEnabled) {
            var animationElementId = 'smasi-action-out-' + this.actionId;
            var animationStyles = document.getElementById(animationElementId);
            if (!animationStyles) {
                var initialPos = element.getBoundingClientRect();
                animationStyles = document.createElement("style");
                animationStyles.id = animationElementId;
                animationStyles.innerHTML = "\n        @keyframes smasi-slideoutleft-{{id}} {\n            from {\n              left: unset;\n              right: {{initialRightPosition}};\n              margin-left: unset;\n              margin-right: unset;\n              }\n\n            to {\n              left: unset;\n              right: 100%;\n              margin-left: unset;\n              margin-right: unset;\n            }\n          }\n\n          @keyframes smasi-slideoutright-{{id}} {\n            from {\n              right: unset;\n              left: {{initialLeftPosition}};\n              margin-left: unset;\n              margin-right: unset;\n              }\n\n            to {\n              right: unset;\n              left: 100%;\n              margin-left: unset;\n              margin-right: unset;\n            }\n          }\n\n          @keyframes smasi-slideouttop-{{id}} {\n            from {\n              top: unset;\n              bottom: {{initialBottomPosition}};\n              margin-top: unset;\n              margin-bottom: unset;\n            }\n\n            to {\n              top: unset;\n              bottom: 100%;\n              margin-top: unset;\n              margin-bottom: unset;\n            }\n          }\n\n          @keyframes smasi-slideoutbottom-{{id}} {\n            from {\n              bottom: unset;\n              top: {{initialTopPosition}};\n              margin-top: unset;\n              margin-bottom: unset;\n              }\n            to {\n              bottom: unset;\n              top: 100%;\n              margin-top: unset;\n              margin-bottom: unset;\n            }\n        }\n                   ".replace(/{{initialRightPosition}}/g, (this.getWindowWidth() - initialPos.right) + "px")
                    .replace(/{{initialLeftPosition}}/g, initialPos.left + "px")
                    .replace(/{{initialBottomPosition}}/g, (this.getWindowHeight() - initialPos.bottom) + "px")
                    .replace(/{{initialTopPosition}}/g, initialPos.top + "px")
                    .replace(/{{id}}/g, this.actionId);
                element.appendChild(animationStyles);
            }
            var animationName = "";
            if (this.slideOutSide == "3" /* left */)
                animationName = 'smasi-slideoutleft';
            else if (this.slideOutSide == "4" /* right */)
                animationName = 'smasi-slideoutright';
            else if (this.slideOutSide == "1" /* top */)
                animationName = 'smasi-slideouttop';
            else if (this.slideOutSide == "2" /* bottom */)
                animationName = 'smasi-slideoutbottom';
            animations.push(animationName + "-" + this.actionId + " " + this.slideOutTransition + "ms" + " linear forwards");
        }
        if (this.fadeOutEnabled) {
            animations.push("fadeout-" + this.actionId + " " + this.fadeOutTransition + "ms" + " linear forwards");
        }
        element.style.animation = animations.join(",");
        element.style.animationPlayState = "paused";
    };
    Overlay.prototype.iframeStyle = function () {
        if (this.iframe.addEventListener) {
            this.iframe.addEventListener('load', this._onContentLoaded);
        }
        else if (this.iframe.attachEvent) {
            this.iframe.attachEvent('onload', this._onContentLoaded);
        }
        this.iframe.frameBorder = "0";
        this.iframe.setAttribute("frameBorder", "0");
        var iframeStyle = this.iframe.style;
        iframeStyle.zIndex = "100010";
        iframeStyle.border = "0";
        iframeStyle.width = '100%';
        iframeStyle.height = '100%';
        iframeStyle.display = "block";
        if (this.transparent) {
            this.iframe.setAttribute('allowTransparency', 'true');
        }
        else {
            iframeStyle.backgroundColor = "white";
        }
    };
    Overlay.prototype.isFullWidth = function () {
        return !this.useDynamicDimensions && this.widthUnit == Overlay.unit.PERCENTAGE && this.width == 100;
    };
    Overlay.prototype.isFullHeight = function () {
        return !this.useDynamicDimensions && this.heightUnit == Overlay.unit.PERCENTAGE && this.height == 100;
    };
    Overlay.prototype.create = function () {
        var _this = this;
        var that = this;
        if (this.isIOS() && this.IOSFlexiblePositioning) {
            this.setBodyIOSHack();
        }
        var body = document.getElementsByTagName("body")[0];
        this.rootElement = document.createElement("div");
        this.divOnIframe = document.createElement("div");
        this.iframe = document.createElement("iframe");
        this.btnClose = document.createElement("img");
        this.overlay = document.createElement("div");
        this.iframe.title = "SmartSignalsIFrame";
        if (window.addEventListener) {
            window.addEventListener('resize', this._onResize);
            window.addEventListener('orientationchange', this.onOrientationChange);
            /*window.addEventListener('scroll', this._onScroll)*/
        }
        else if (window.attachEvent) {
            window.attachEvent('onresize', this._onResize);
            window.attachEvent('onorientationchange', this.onOrientationChange);
            //(<any>window).attachEvent('onscroll', this._onScroll);
        }
        if (this.closeOnOuterClick) {
            this.rootElement.onmouseover = function () { return _this._onRootElementMouseOver(); };
            this.rootElement.onmouseout = function () { return _this._onRootElementMouseOut(); };
        }
        this.cssReset(this.rootElement);
        this.cssReset(this.btnClose);
        this.cssReset(this.overlay);
        this.cssReset(this.divOnIframe);
        this.cssReset(this.iframe);
        this.rootElementStyle();
        this.btnCloseStyle();
        this.overlayStyle();
        this.divOnIframeStyle();
        this.iframeStyle();
        this.hideInternal();
        if (this.cssClasses)
            this.cssClasses.map(function (i) { return _this.rootElement.classList.add(i); });
        this.rootElement.appendChild(this.divOnIframe);
        this.divOnIframe.appendChild(this.iframe);
        this.rootElement.appendChild(this.btnClose);
        this.setContentURL(this.contentUrl);
        body.appendChild(this.rootElement);
        body.appendChild(this.overlay);
    };
    Overlay.prototype.getVisibility = function () {
        return this.isHidden ? VisibilityState.hidden : this.opened && this.readyToShow ? VisibilityState.shown : VisibilityState.none;
    };
    Overlay.prototype.isModal = function () {
        return this.modal;
    };
    Overlay.prototype.getRootRect = function () {
        if (!this.rootElement || !this.readyToShow)
            return undefined;
        return this.rootElement.getBoundingClientRect();
    };
    Overlay.prototype.show = function (hideGroup) {
        this.hiddenGroups = this.hiddenGroups.filter(function (x) { return x !== hideGroup; });
        if (this.hiddenGroups.length)
            return;
        this.isHidden = false;
        this.doShow(false);
    };
    Overlay.prototype.showInternal = function () {
        this.readyToShow = true;
        this.doShow(true);
    };
    Overlay.prototype.doShow = function (internal) {
        if (!this.opened || this.TestMode || !this.readyToShow)
            return;
        if (this.onReadyToShow && !this.onReadyToShowCalled) {
            this.onReadyToShowCalled = true;
            this.onReadyToShow();
        }
        if (internal && this.onShowTrigger && this.onShowTrigger() === false)
            return;
        if (this.isShown || this.isHidden)
            return;
        this.isShown = true;
        if (this.slideInEnabled || this.fadeInEnabled)
            this.createInAnimations(this.rootElement);
        this.rootElement.style.visibility = "visible";
        this.divOnIframe.style.visibility = "visible";
        this.iframe.style.visibility = "visible";
        this.overlay.style.visibility = "visible";
        this.btnClose.style.visibility = "visible";
        if (this.isAnimationSupported) {
            this.rootElement.style.animationPlayState = "running";
        }
        if (this.boxShadow) {
            var bs = this.boxShadow;
            this.divOnIframe.style.boxShadow = "" + bs.horizontalOffset + "px " + bs.verticalOffset + "px " + bs.blur + "px " + bs.spread + "px " + bs.color;
        }
        if (this.modal) {
            if (!this.htmlStyleBackup) {
                var currentHtmlStyle = window.document.documentElement.style;
                this.htmlStyleBackup = this.createStyleBackup(currentHtmlStyle);
                currentHtmlStyle.overflow = currentHtmlStyle.overflowX = currentHtmlStyle.overflowY = "hidden";
            }
            if (!this.bodyStyleBackup) {
                var currentBodyStyle = window.document.body.style;
                this.bodyStyleBackup = this.createStyleBackup(currentBodyStyle);
                currentBodyStyle.overflow = currentBodyStyle.overflowX = currentBodyStyle.overflowY = "hidden";
            }
        }
        this.callOnOpen();
        return;
    };
    Overlay.prototype.callOnOpen = function () {
        try {
            if (!this.onOpenCalled && this.onOpen) {
                this.onOpenCalled = true;
                this.onOpen();
            }
        }
        catch (e) { }
    };
    Overlay.prototype.hide = function (hideGroup) {
        if (this.hiddenGroups.indexOf(hideGroup) == -1)
            this.hiddenGroups.push(hideGroup);
        this.isHidden = true;
        this.doHide();
    };
    Overlay.prototype.hideInternal = function () {
        this.readyToShow = false;
        this.doHide();
    };
    Overlay.prototype.doHide = function () {
        this.rootElement.style.visibility = "hidden";
        this.divOnIframe.style.visibility = "hidden";
        this.iframe.style.visibility = "hidden";
        this.overlay.style.visibility = "hidden";
        this.btnClose.style.visibility = "hidden";
        this.restoreStyleBackup(this.bodyStyleBackup, window.document.body.style);
        this.restoreStyleBackup(this.htmlStyleBackup, window.document.documentElement.style);
        this.bodyStyleBackup = undefined;
        this.htmlStyleBackup = undefined;
        this.isShown = false;
    };
    Overlay.prototype._updateDynamicSize = function (force) {
        var _this = this;
        if (!this.opened) {
            this._showContent();
        }
        var maxSize = this.getMaxSize();
        var rootElementStyle = this.rootElement.style;
        var divOnIframeStyle = this.divOnIframe.style;
        rootElementStyle.maxWidth = maxSize.width + Overlay.unit.PIXEL;
        if (!this.isIOS() || this.IOSFlexiblePositioning)
            rootElementStyle.maxHeight = maxSize.height + Overlay.unit.PIXEL;
        //else
        //    rootElementStyle.maxHeight = "none";
        if (!this.useDynamicDimensions) {
            this.resizeStaticRootDiv(!force);
            this.showInternal();
            return;
        }
        if (force) {
            this.rootElement.style.width = maxSize.width + Overlay.unit.PIXEL;
            this.rootElement.style.height = maxSize.height + Overlay.unit.PIXEL;
        }
        this.getDimensions(maxSize, function (dimensions) {
            _this.setDimensions(dimensions, maxSize);
            _this.getDimensions(maxSize, function (dimensions) {
                _this.setDimensions(dimensions, maxSize);
                _this.showInternal();
            }, _this.onError, _this.communicationTimeoutMs);
        }, this.onError, this.communicationTimeoutMs);
    };
    Overlay.prototype.resizeStaticRootDiv = function (ignoreCalc) {
        if (ignoreCalc === void 0) { ignoreCalc = false; }
        if (this.isCssCalcSupported()) {
            if (!ignoreCalc) {
                if (this.widthUnit === Overlay.unit.PERCENTAGE && (this.marginLeft != 0 || this.marginRight != 0)) {
                    this.rootElement.style.width = "calc(" + this.width + this.widthUnit + " - " + this.marginLeft + this.marginLeftUnit + " - " + this.marginRight + this.marginRightUnit + ")";
                }
                else {
                    this.rootElement.style.width = this.width + this.widthUnit;
                }
                if (this.heightUnit === Overlay.unit.PERCENTAGE && (this.marginTop != 0 || this.marginBottom != 0)) {
                    this.rootElement.style.height = "calc(" + this.height + this.heightUnit + " - " + this.marginTop + this.marginTopUnit + " - " + this.marginBottom + this.marginBottomUnit + ")";
                }
                else {
                    this.rootElement.style.height = this.height + this.heightUnit;
                }
            }
        }
        else {
            this.rootElement.style.width = !this.isFullWidth() ? (this.width + this.widthUnit) : "auto";
            this.rootElement.style.height = !this.isFullHeight() ? (this.height + this.heightUnit) : "auto";
        }
        if (this.isIOS() && !this.IOSFlexiblePositioning) {
            this.AdjustIOSOverlayPosition();
        }
    };
    Overlay.prototype.isCssCalcSupported = function () {
        var el = document.createElement('a');
        el.style.cssText = 'width:calc(10px);';
        return !!el.style.length;
    };
    Overlay.prototype.getOverlayMSize = function (onError, onSuccess, timeout) {
        var call = {
            method: "overlayMSize",
            params: null,
            success: onSuccess,
            timeout: timeout,
            error: onError
        };
        this.chan.call(call);
    };
    Overlay.prototype.getDimensions = function (params, onSuccess, onError, timeout) {
        var call = {
            method: "getDimensionsV2",
            params: params,
            success: onSuccess,
            timeout: timeout,
            error: onError
        };
        this.chan.call(call);
    };
    Overlay.prototype.resize = function (force) {
        var rootElementStyle = this.rootElement.style;
        //if (!this.resizeTimer) {
        //    this.resizeTimer = setTimeout(() => {
        //        this.resizeTimer = undefined;
        this._updateDynamicSize(force);
        //    }, 200);
        //}
        if (this.isIE8()) {
            var h = document.documentElement.clientHeight / 100.0 * 90.0;
            if (h < this.height) {
                rootElementStyle.visibility = "hidden";
                rootElementStyle.height = h.toString() + Overlay.unit.PIXEL;
                rootElementStyle.visibility = "visible";
            }
            else {
                if (rootElementStyle.height !== this.height.toString() + Overlay.unit.PIXEL) {
                    rootElementStyle.visibility = "hidden";
                    rootElementStyle.height = this.height.toString() + Overlay.unit.PIXEL;
                    rootElementStyle.visibility = "visible";
                }
            }
        }
    };
    Overlay.prototype._contentHandshake = function (externalConfig) {
        this.setExternalConfigOrDefault(externalConfig);
        this.communicationReady = true;
        if (this.openRequest) {
            this.open();
        }
    };
    Overlay.prototype.setExternalConfigOrDefault = function (externalConfig) {
        if (externalConfig === void 0) { externalConfig = {}; }
        externalConfig = externalConfig || {};
        this.externalConfig = {
            asyncContent: externalConfig.asyncContent || false
        };
    };
    Overlay.prototype._contentDOMChanged = function () {
        if (!this.opened)
            return;
        //this._updateDynamicSize();
    };
    Overlay.prototype._asyncContentReady = function () {
        this.asyncContentReady = true;
        if (this.openRequest) {
            this.open();
        }
    };
    Overlay.prototype._sizeChanged = function () {
        var _this = this;
        setTimeout(function () {
            _this._updateDynamicSize(false);
        }, 0);
    };
    Overlay.prototype._clicked = function () {
        try {
            if (this.onContentClicked)
                this.onContentClicked();
        }
        catch (e) { }
    };
    Overlay.prototype._showContent = function () {
        this.contentLoaded = true;
        if (this.openRequest) {
            this.open();
        }
    };
    Overlay.prototype._onCloseBtnClicked = function () {
        this.closeByUser(true);
    };
    Overlay.prototype._onRootElementMouseOver = function () {
        this.rootElementHovered = true;
    };
    Overlay.prototype._onRootElementMouseOut = function () {
        this.rootElementHovered = false;
    };
    Overlay.prototype.cssReset = function (element) {
        this.setCssDefaults(element);
        var node;
        for (var i = 0; i < element.childNodes.length; ++i) {
            node = element.childNodes[i];
            if (node.nodeType == node.ELEMENT_NODE) {
                this.cssReset(node);
            }
        }
    };
    Overlay.prototype.getWindowInnerSize = function () {
        return {
            width: (document.documentElement.clientWidth || window.innerWidth || document.body.clientWidth),
            height: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
        };
    };
    //ontouchstart = (event: Event) => {
    //    console.warn("ontouchstart-" + event.target.nodeName + "-" + event.target.id);
    //    let p = event.target;
    //    while (p != null) {
    //        if (p == this.rootElement) {
    //            console.warn("ontouchstart-root");
    //            return;
    //        }
    //        p = p.parentNode;
    //    }
    //    event.preventDefault();
    //}
    //private ontouchmove(event: Event) {
    //    console.warn("ontouchmove-" + event.target.nodeName + "-" + event.target.id);
    //    event.preventDefault();
    //}
    Overlay.prototype.setBodyIOSHack = function () {
        if (!this.isIOS())
            return;
        var style = document.createElement('style');
        style.id = 'styleIosHack';
        style.type = 'text/css';
        style.innerHTML = 'html, body { -webkit-overflow-scrolling: touch !important; overflow: auto !important; height: 100 % !important; }';
        document.getElementsByTagName('head')[0].appendChild(style);
    };
    Overlay.prototype.unsetBodyIOSHack = function () {
        if (!this.isIOS())
            return;
        var style = document.getElementById('styleIosHack');
        if (style)
            document.getElementsByTagName('head')[0].removeChild(style);
    };
    Overlay.prototype.setCssDefaults = function (element) {
        element.style.animation = "none";
        element.style.backfaceVisibility = "visible";
        element.style.background = "0";
        element.style.backgroundAttachment = "scroll";
        element.style.backgroundClip = "border-box";
        element.style.backgroundImage = "none";
        element.style.backgroundOrigin = "padding - box";
        element.style.backgroundPosition = "0 0";
        element.style.backgroundRepeat = "repeat";
        element.style.backgroundSize = "auto auto";
        element.style.border = "0";
        element.style.borderStyle = "none";
        element.style.borderRadius = "0";
        element.style.borderSpacing = "0";
        element.style.bottom = "auto";
        element.style.boxShadow = "none";
        element.style.boxSizing = "content-box";
        element.style.captionSide = "top";
        element.style.clear = "none";
        element.style.color = "inherit";
        element.style.columns = "auto";
        element.style.columnCount = "auto";
        element.style.columnFill = "balance";
        element.style.columnGap = "normal";
        element.style.columnRule = "medium none currentColor";
        element.style.columnSpan = "1";
        element.style.columnWidth = "auto";
        element.style.content = "normal";
        element.style.counterIncrement = "none";
        element.style.counterReset = "none";
        element.style.cursor = "auto";
        element.style.direction = "ltr";
        element.style.display = "block";
        element.style.emptyCells = "show";
        element.style.cssFloat = "none";
        element.style.height = "auto";
        //element.style.msHyphens = "none";
        element.style.left = "auto";
        element.style.letterSpacing = "normal";
        element.style.lineHeight = "normal";
        element.style.listStyle = "none";
        element.style.margin = "0";
        element.style.maxHeight = "none";
        element.style.maxWidth = "none";
        element.style.minHeight = "0";
        element.style.minWidth = "0";
        element.style.opacity = "1";
        element.style.orphans = "0";
        element.style.outline = "0";
        element.style.outlineStyle = "none";
        element.style.overflow = "visible";
        element.style.padding = "0";
        element.style.pageBreakAfter = "auto";
        element.style.pageBreakBefore = "auto";
        element.style.pageBreakInside = "auto";
        element.style.perspective = "none";
        element.style.perspectiveOrigin = "50% 50%";
        element.style.position = "static";
        element.style.right = "auto";
        element.style.tableLayout = "auto";
        element.style.textAlign = "inherit";
        element.style.textDecoration = "none";
        element.style.textIndent = "0";
        element.style.textShadow = "none";
        element.style.textTransform = "none";
        element.style.top = "auto";
        element.style.transform = "none";
        element.style.transformStyle = "flat";
        element.style.transition = "none";
        element.style.unicodeBidi = "normal";
        element.style.verticalAlign = "baseline";
        element.style.visibility = "visible";
        element.style.whiteSpace = "normal";
        element.style.widows = "0";
        element.style.width = "auto";
        element.style.wordSpacing = "normal";
        element.style.zIndex = "auto";
    };
    Overlay.prototype.panelAction = function (trans, innerAction) {
        try {
            if (this.onPanelAction) {
                this.onPanelAction(innerAction, trans);
            }
            // if (closePanel) {
            //     this.closeByUser();
            //     window.setTimeout(() => { this.destroy(); }, 0); // Leave the jschannel call, than destroy
            // }
        }
        catch (e) { }
    };
    Overlay.prototype.destroy = function () {
        if (this.isIOS() && this.IOSFlexiblePositioning) {
            this.unsetBodyIOSHack();
        }
        if (this.destroyed)
            return;
        this.close();
        if (window.removeEventListener) {
            window.removeEventListener('resize', this._onResize);
            window.removeEventListener('orientationchange', this.onOrientationChange);
            //window.removeEventListener('scroll', this._onScroll)
        }
        else if (window.detachEvent) {
            window.detachEvent('onresize', this._onResize);
            window.detachEvent('onorientationchange', this.onOrientationChange);
            //(<any>window).detachEvent('onscroll', this._onScroll);
        }
        this.destroyed = true;
        if (this.rootElement.parentNode) {
            this.rootElement.parentNode.removeChild(this.rootElement);
        }
        if (this.overlay.parentNode) {
            this.overlay.parentNode.removeChild(this.overlay);
        }
        if (this.chan)
            this.chan.destroy();
    };
    Overlay.prototype.createStyleBackup = function (from) {
        return {
            overflow: from.overflow,
            overflowX: from.overflowX,
            overflowY: from.overflowY
        };
    };
    Overlay.prototype.restoreStyleBackup = function (from, into) {
        if (from && into) {
            into.overflow = from.overflow;
            into.overflowX = from.overflowX;
            into.overflowY = from.overflowY;
        }
    };
    Overlay.prototype.setupContentScript = function () {
        var call = {
            method: "setup",
            params: {
                closeOnEscKey: this.closeOnEscKey
            },
            success: function () { },
            error: this.onContentScriptSetupError,
            timeout: 1000
        };
        this.chan.call(call);
    };
    Overlay.unit = {
        PIXEL: "px",
        PERCENTAGE: "%"
    };
    Overlay.horizontalSnap = {
        LEFT: "left",
        CENTER: "center",
        RIGHT: "right",
    };
    Overlay.verticalSnap = {
        TOP: "top",
        CENTER: "center",
        BOTTOM: "bottom"
    };
    return Overlay;
}());
exports.Overlay = Overlay;
